import React, { useMemo } from 'react';
import { View } from 'react-native';
import { s } from '../../utils/libs';
import { getChartTooltipTranslateX } from './chartTooltipPosition';

type Props = {
  pointX: number;
  tooltipWidth: number;
  boundaryWidth: number;
  gap?: number;
  translateY?: number;
  children: React.ReactNode;
};

const PositionedChartTooltip: React.FC<Props> = ({
  pointX,
  tooltipWidth,
  boundaryWidth,
  gap = s(8),
  translateY = 0,
  children,
}) => {
  const translateX = useMemo(
    () =>
      getChartTooltipTranslateX({
        pointX,
        tooltipWidth,
        boundaryWidth,
        gap,
      }),
    [pointX, tooltipWidth, boundaryWidth, gap],
  );

  return (
    <View style={{ transform: [{ translateX }, { translateY }] }}>
      {children}
    </View>
  );
};

export default PositionedChartTooltip;
